import React, { useEffect, useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  IconButton,
  Typography
} from '@mui/material'
import ReplayIcon from '@mui/icons-material/Replay'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { getPersonPositions, type Position } from 'services'
import { PositionsStack, useGlobalMessageHandler } from 'components'
import { formatErrorFieldMessages } from 'interfaces'

export interface PersonPositionsProps {
  personId: number
  showSuccessMessage: (message: string) => void
  showErrorMessage: (message: string) => void
}
export const PersonPositionsBlock: React.FC<PersonPositionsProps> = ({ personId }) => {
  const [expanded, setExpanded] = useState(true)
  const [positions, setPositions] = useState<Position[]>([])
  const [loading, setLoading] = useState(true)
  const [reloadPositions, setReloadPositions] = useState<boolean>(false)
  const [erroredLoading, setErroredLoading] = useState<boolean>(false)
  const { showErrorMessage } = useGlobalMessageHandler()

  useEffect(() => {
    setLoading(true)
    setErroredLoading(false)
    getPersonPositions(personId).then((positions) => {
      if (positions.succeeded && positions.result !== null) {
        setPositions(positions.result)
      } else {
        showErrorMessage(formatErrorFieldMessages(positions.errors))
        setErroredLoading(true)
      }
    }).catch(() => {
      showErrorMessage('Error Retrieving Positions')
      setErroredLoading(true)
    })
      .finally(() => {
        setLoading(false)
      }
      )
  }, [reloadPositions])

  const handleAccordionChange = (): void => {
    setExpanded(!expanded)
  }

  const triggerReload = async (): Promise<void> => {
    setReloadPositions(prevState => !prevState)
  }

  return (
        <Card sx={{ borderRadius: '12px', width: '100%' }}>
            <Accordion expanded={expanded} onChange={handleAccordionChange}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <Typography variant="h6">Positions</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <CardContent>
                        {erroredLoading
                          ? <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant="body1" color="error" sx={{ mb: 2 }}>
                                An error occurred while retrieving positions.
                            </Typography>
                            <IconButton color="primary" size={'medium'} onClick={() => { void triggerReload() }} sx={{ alignSelf: 'center' }}>
                                <ReplayIcon sx={{ fontSize: '5vh' }}/>
                            </IconButton>
                        </CardContent>
                          : <PositionsStack personId={personId} loading={loading} positions={positions} triggerReload={triggerReload}/>
                        }
                    </CardContent>
                </AccordionDetails>
            </Accordion>
        </Card>
  )
}
